<template>
	<div class="hiq-article-list">
		<article-filters></article-filters>
		<article-filter-remover></article-filter-remover>
		<article-sort></article-sort>
		<article-message></article-message>
		<article-items></article-items>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';
import ArticleFilters from './components/ArticleFilters.vue';
import ArticleSort from './components/ArticleSort.vue';
import ArticleMessage from './components/ArticleMessage.vue';
import ArticleItems from './components/ArticleItems.vue';
import ArticleFilterRemover from './components/ArticleFilterRemover.vue';

// Interfaces for component typechecking!
interface AppData {

}

interface AppMethods {

}

interface AppComputed {

}

interface AppProps {

}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
	name: 'app',
	computed: {

	},
	methods: {

	},
	components: {
		ArticleFilters,
		ArticleSort,
		ArticleMessage,
		ArticleItems,
		ArticleFilterRemover
	}
})
</script>
